var exports = {
  "kL": "x7be19a29--e79f65--container",
  "Qs": "x7be19a29--e79f65--content",
  "om": "x7be19a29--e79f65--block",
  "Ov": "x7be19a29--e79f65--tech-title",
  "TN": "x7be19a29--e79f65--groups",
  "Os": "x7be19a29--e79f65--group",
  "nM": "x7be19a29--e79f65--row",
  "Uq": "x7be19a29--e79f65--value",
  "VA": "x7be19a29--e79f65--subtitle",
};

module.exports = exports;
